import React from 'react'

const Footer = () => (
    <div className="mt-8 text-center">
        <p className="text-xs text-gray-500">
            © 2024 VoxCity Tecnologia - Portal Interno de Funcionários
        </p>
    </div>
)

export default Footer